module.exports = __webpack_public_path__ + "img/related-ans-icon.9e4853ec.svg";